import React, { useState } from 'react';
import { Button } from '../ui/button';
import { livechatMiningAPI } from '../../services/api';
import { downloadPatternMetadataCsv, downloadPatternConversationsJson } from './patternExport';

// Fetches every thread behind the pattern under the same filters as the drill-down table
// (params mirror what's currently narrowing that table) and downloads it, either as
// metadata-only CSV (for spreadsheet analysis) or full transcripts as JSON.
const PatternExportButtons = ({ pattern, params }) => {
  const [loadingKind, setLoadingKind] = useState(null);
  const [error, setError] = useState('');
  const [truncated, setTruncated] = useState(false);

  const runExport = async (kind) => {
    try {
      setLoadingKind(kind);
      setError('');
      setTruncated(false);
      const resp = await livechatMiningAPI.getPatternExport(
        pattern, params.from, params.to, params.lifecycleState, params.activityState,
        params.actionability, params.signalType, params.topic, params.search, params.sortOrder,
      );
      const threads = resp.data.threads || [];
      if (kind === 'csv') downloadPatternMetadataCsv(pattern, threads);
      else downloadPatternConversationsJson(pattern, threads);
      if (resp.data.truncated) setTruncated(true);
    } catch {
      setError('Export failed.');
    } finally {
      setLoadingKind(null);
    }
  };

  return (
    <div className="flex flex-col items-end gap-1">
      <div className="flex items-center gap-2 flex-wrap">
        <Button variant="outline" size="sm" disabled={loadingKind != null} onClick={() => runExport('csv')}>
          {loadingKind === 'csv' ? 'Exporting…' : 'Export metadata (CSV)'}
        </Button>
        <Button variant="outline" size="sm" disabled={loadingKind != null} onClick={() => runExport('json')}>
          {loadingKind === 'json' ? 'Exporting…' : 'Export conversations (JSON)'}
        </Button>
        {error && <span className="text-[11px] text-negative">{error}</span>}
      </div>
      {truncated && (
        <span className="text-[11px] text-warning">
          This pattern has more matching conversations than fit in one export — narrow your filters to get the rest.
        </span>
      )}
    </div>
  );
};

export default PatternExportButtons;
